import { z } from 'zod/v4-mini';

export const genderSchema = z.literal(['male', 'female']);
export type Gender = z.infer<typeof genderSchema>;
